export const onAuthenticate = () => {
  if (window.opener?.location?.pathname?.startsWith('/embed/')) {
    const data = { type: 'reload' }
    window.postMessage(JSON.stringify(data), window.location.href)
  }
}
